export const editorStatusLoadingWrapperForPromise = (dispatch) => {
  dispatch({
    type: 'SET_LOADING',
    payload: true,
  });

  return () => {
    dispatch({
      type: 'SET_LOADING',
      payload: false,
    });
  };
};

export const DEFER_EDITOR_JOB = {
  SAVE: 'save',
  PUBLISH: 'publish',
  NONE: 'none',
  RUNNING: 'running',
};

export const editorStatusReducer = (state, action) => {
  switch (action.type) {
    case 'EDIT_COMPONENT_TYPE': {
      const {
        selectedComponentType,
        editingComponentType,
        editingComponentId,
        editingComponentProperty,
        isPreviewSelecting,
      } = action.payload;

      return {
        ...state,
        selectedComponentType: selectedComponentType || editingComponentType,
        editingComponentType,
        editingComponentId,
        editingComponentProperty,
        isPreviewSelecting,
        skipSaving: null,
      };
    }
    case 'CANCEL_COMPONENT_EDIT': {
      const { skipSaving } = action.payload || {};

      return {
        ...state,
        selectedComponentType: null,
        editingComponentType: null,
        editingComponentProperty: null,
        editingComponentId: null,
        isPreviewSelecting: null,
        skipSaving,
      };
    }
    case 'SET_VIEW':
      return {
        ...state,
        view: action.payload,
      };
    case 'SET_LOADING':
      return {
        ...state,
        loading: action.payload,
      };
    case 'SET_FLOATING_BANNER':
      return {
        ...state,
        floatingBanner: action.payload,
      };
    case 'CONFIRMING_PUBLISH':
      return {
        ...state,
        isConfirming: true,
        showResultModalDialog: true,
      };
    case 'BEGIN_PUBLISH':
      return {
        ...state,
        isPublishing: true,
        failedToPublish: false,
        showResultModalDialog: true,
        isConfirming: false,
      };
    case 'END_PUBLISH': {
      const newState = {
        ...state,
        isPublishing: false,
        isPublished: true,
        showResultModalDialog: action.payload.showResultModalDialog,
        subDomain: action.payload.subDomain,
        siteSuffix: action.payload.siteSuffix,
      };

      if (!action.payload.showResultModalDialog) {
        newState.isConfirming = false;
      }

      return newState;
    }
    case 'SWITCH_PREVIEW_MODE':
      return {
        ...state,
        previewMode: action.payload,
      };
    case 'HIDE_PUBLISH_DIALOG':
      return {
        ...state,
        showResultModalDialog: false,
        isConfirming: false,
      };
    case 'FAILED_TO_PUBLISH':
      return {
        ...state,
        failedToPublish: true,
        isPublishing: false,
        isPublished: false,
        isConfirming: false,
      };
    case 'BEGIN_REVERT':
      return {
        ...state,
        isReverting: true,
      };
    case 'END_REVERT':
      return {
        ...state,
        isReverting: false,
      };
    case 'SET_ON_EXIT_COMPONENT_EDITING_EFFECT':
      return {
        ...state,
        onBeforeExitEditing: action.payload || (() => Promise.resolve(null)),
      };
    case 'RESET_ON_EXIT_COMPONENT_EDITING_EFFECT':
      return {
        ...state,
        onBeforeExitEditing: () => Promise.resolve(null),
      };
    case 'TRIGGER_DEFER_SAVE':
      return {
        ...state,
        deferEditorJob: DEFER_EDITOR_JOB.SAVE,
        deferCallback: (action.payload && action.payload.callback) || (() => Promise.resolve(null)),
        deferParameters: (action.payload && action.payload.parameters) || {},
      };
    case 'TRIGGER_DEFER_PUBLISH':
      return {
        ...state,
        deferEditorJob: DEFER_EDITOR_JOB.PUBLISH,
        deferCallback: action.payload || (() => Promise.resolve(null)),
      };
    case 'RUNNING_DEFER_JOB':
      return {
        ...state,
        deferEditorJob: DEFER_EDITOR_JOB.RUNNING,
        deferCallback: () => Promise.resolve(null),
      };
    case 'RESET_DEFER_JOB':
      return {
        ...state,
        deferEditorJob: DEFER_EDITOR_JOB.NONE,
        deferCallback: () => Promise.resolve(null),
        deferParameters: {},
      };
    case 'SET_COMPONENTS_VALIDATION':
      return {
        ...state,
        componentsValidation: action.payload,
      };
    case 'FORCE_EDITOR_UPDATE':
      return {
        ...state,
        forceEditorUpdate: true,
      };
    case 'RESET_FORCE_EDITOR_UPDATE':
      return {
        ...state,
        forceEditorUpdate: false,
      };
    case 'SHOW_FEEDBACK_PANEL':
      return {
        ...state,
        showFeedbackPanel: true,
      };
    case 'HIDE_FEEDBACK_PANEL':
      return {
        ...state,
        showFeedbackPanel: false,
      };
    // Used as a central state store to keep editor level data
    // which could be shared in different component editors
    case 'PATCH_BUFFER_STATE':
      return {
        ...state,
        buffer: {
          ...state.buffer,
          ...action.payload,
        },
      };
    case 'SHOW_MOBILE_ERROR_MASK':
      return {
        ...state,
        isHideMobileErrorMask: false,
      };
    case 'BEGIN_SAVE':
      return {
        ...state,
        isSaving: true,
      };
    case 'END_SAVE':
      return {
        ...state,
        isSaving: false,
      };
    default: throw new Error(`Unsuported action type: ${action.type}`);
  }
};
